module.exports = __webpack_public_path__ + "img/icon3.d702a4e8.png";